import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {User} from '../models/user';
import {map} from 'rxjs/operators';
import * as JWT from 'jwt-decode';
import {Observable} from 'rxjs';

declare var jwt_decode: any;

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/users';

@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private router: Router) { }

  login(username: string, password: string) {
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tokenExp');
    return this.http.post<any>('/api/v1/auth/signin',
      { username : username, password: password, device :  'WEB'})
      .pipe(
        map(token => {
          // login successful if there's a jwt token in the response
          // use JWT() for decode. Not jwt-decode() !!
          let t: any;
          t = JWT(token.accessToken);
          localStorage.setItem('token', token.accessToken);
          localStorage.setItem('tokenExp', t.exp);
          localStorage.setItem('currentUser', JSON.stringify(t.currentUser));
          localStorage.setItem('operateur', 'TT');
          return t;
        })
      );
  }

  forgotpassword(email: string): Observable<any> {
    const params = new HttpParams()
      .set('email', String(email));
    const url = `${apiUrl}/forgotpassword`;
    return this.http.get<any>(url, {params});
  }

  resetpassword(token: string, password: string): Observable<any> {
    const body = {token: String(token), password: String(password)};
    const url = `${apiUrl}/resetpassword`;
    return this.http.post<any>(url, body);
  }

  logout() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    ///users/logout/id
    if (currentUser) {
      const params = new HttpParams();
      const url = `${apiUrl}/logout/` + currentUser.id;
      return this.http.get<any>(url, {params});
    }
  }

  hasPermission(authArr: string[]) {
    let currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
    for (let j in authArr) {
      if (currentUser.role === authArr[j] || authArr[j] === '*') {
        return true;
      }
    }
    return false;
  }
}
